import FontAwesome from '@expo/vector-icons/FontAwesome';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import Checkbox from '@/components/ui/therapist/Checkbox';

export function TextRow({
  isSelected,
  wholeObject,
  simpleBody,
  body,
  hasTags,
  title,
  tags,
  onPress,
  selectedLimit,
  insideSelected,
  handleTextClick,
  textLength,
}) {
  const handlePress = useCallback((wholeObject, isSelected) => {
    return () => {
      onPress(wholeObject, isSelected, true);
    };
  }, []);

  const handleTextPress = useCallback(() => {
    const data = {
      header: title,
      body: (textLength === 'kurz' ? simpleBody : body)?.replace(
        /[\[\]']+/g,
        '',
      ),
    };
    handleTextClick(data);
  }, [textLength]);

  const isDisabled = () => {
    if (selectedLimit && !isSelected) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <PressableNeolexon
      style={styles.rowWrapper}
      onPress={
        insideSelected
          ? handlePress(wholeObject, true)
          : handlePress(wholeObject, isSelected)
      }
    >
      <View style={styles.rowContainer}>
        <View style={[styles.rowFlexThree]}>
          {!insideSelected ? (
            <View style={[refinement.viewStyle, refinement.padding]}>
              <PressableNeolexon
                onPress={handleTextPress}
                style={refinement.viewStyle}
              >
                <MaterialCommunityIcons
                  name="file-search-outline"
                  size={24}
                  color="#3279B7"
                />
                <Text style={refinement.textColor}>Textvorschau</Text>
              </PressableNeolexon>
            </View>
          ) : null}
          <Text style={styles.tagsTitle}>
            {title} ({textLength})
          </Text>
          {hasTags ? (
            <View style={styles.tagsContainer}>
              {tags.map((tag) => (
                <View style={styles.tag} key={tag}>
                  <Text style={styles.tagText}>{tag}</Text>
                </View>
              ))}
            </View>
          ) : null}
        </View>
        <View style={[styles.rowFlexOne, styles.rowContainerAction]}>
          {insideSelected ? (
            <FontAwesome name="close" size={20} color={colors.darkGrey} />
          ) : (
            <Checkbox
              onPress={() => onPress(wholeObject, isSelected, true)}
              label={''}
              isSelected={isSelected}
              disabled={isDisabled()}
            />
          )}
        </View>
      </View>
    </PressableNeolexon>
  );
}

const refinement = StyleSheet.create({
  viewStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textColor: {
    color: '#3279B7',
  },
  padding: { paddingVertical: 5 },
});
